import { all } from "redux-saga/effects";
import { registerSentimentTrackerOnboardingSagas } from "./sentimentTrackerOnboarding/sentimentTrackerOnboardingSaga";

function* registerSentimentTrackerRootSaga() {
    yield all([
        registerSentimentTrackerOnboardingSagas(),
    ]);
}

export { registerSentimentTrackerRootSaga };
